var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useContext, useMemo, useState } from "react";
import { UtilContext } from "@/shared/presentation/context-api/providers/util";
import { AuthContext } from "@/shared/presentation/context-api/providers/auth";
import { EmployeeRolesCodes } from "@/shared/domain/entities/employee";
var initialState = {
    setCompanyUserProfile: function (profile) { return null; },
    addCompanyAddress: function (params) {
        return Promise.resolve(null);
    },
    createCompanyAndOwner: function (params) {
        return Promise.resolve();
    },
};
export var CompanyWizardContext = React.createContext(initialState);
export var CompanyWizardProvider = function (_a) {
    var children = _a.children, entityDatasource = _a.entityDatasource;
    var _b = useState(), companyUserProfile = _b[0], setCompanyUserProfile = _b[1];
    var _c = useState(), createdCompanyId = _c[0], setCreatedCompanyId = _c[1];
    var documentTypes = useContext(UtilContext).documentTypes;
    var clientWallets = useContext(AuthContext).clientWallets;
    var hashDocumentTypeId = useMemo(function () { var _a; return (_a = documentTypes.find(function (_a) {
        var code = _a.code;
        return code === "Hash";
    })) === null || _a === void 0 ? void 0 : _a.id; }, [documentTypes]);
    var addCompanyAddress = function (address) { return __awaiter(void 0, void 0, void 0, function () {
        var tokenCompanyId;
        var _a;
        return __generator(this, function (_b) {
            tokenCompanyId = (_a = clientWallets === null || clientWallets === void 0 ? void 0 : clientWallets[0]) === null || _a === void 0 ? void 0 : _a.rockId;
            return [2 /*return*/, entityDatasource.addCompanyAddress(createdCompanyId || tokenCompanyId, address)];
        });
    }); };
    var createCompanyAndOwner = function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var rockId, employeeRockId, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    return [4 /*yield*/, entityDatasource.createCompany({
                            name: params.name,
                            document: params.documentNumber,
                            documentTypeId: params.documentTypeId,
                            domain: params.website,
                            locationId: params.locationId,
                            platformId: 9,
                            dataLegals: {
                                industryId: params.industryTypeId,
                                tradeName: params.tradeName,
                                employeeRangeId: params.employeeRangeId,
                            },
                        })];
                case 1:
                    rockId = (_a.sent()).rockId;
                    setCreatedCompanyId(rockId);
                    return [4 /*yield*/, entityDatasource.createCompanyEmployee(rockId, {
                            name: companyUserProfile.name,
                            document: companyUserProfile.document,
                            documentTypeId: hashDocumentTypeId,
                            locationId: params.locationId,
                            preferredName: companyUserProfile.preferredName || undefined,
                            user: {
                                email: companyUserProfile.email,
                            },
                        })];
                case 2:
                    employeeRockId = (_a.sent()).rockId;
                    return [4 /*yield*/, entityDatasource.updateEntity(employeeRockId, {
                            name: companyUserProfile.name,
                        })];
                case 3:
                    _a.sent();
                    return [4 /*yield*/, entityDatasource.addEmployeeRole({
                            employeeRockId: employeeRockId,
                            role: EmployeeRolesCodes.OWNER,
                            rockId: rockId,
                        })];
                case 4:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 5:
                    e_1 = _a.sent();
                    throw e_1;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(CompanyWizardContext.Provider, { value: {
            setCompanyUserProfile: setCompanyUserProfile,
            companyUserProfile: companyUserProfile,
            createdCompanyId: createdCompanyId,
            createCompanyAndOwner: createCompanyAndOwner,
            addCompanyAddress: addCompanyAddress,
        } }, children));
};
